import LaravelEcho from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

export const Echo = new LaravelEcho({
  broadcaster: 'pusher',
  id: process.env.MIX_PUSHER_APP_ID,
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  authEndpoint: `${window.location.origin}/api/broadcasting/auth`,
  namespace: undefined,
});

window.Echo = Echo;

export default {
  Echo,
};
